// extracted by mini-css-extract-plugin
export default {"mm-faq-page":"_7AV2Xv8jxw86jaaAp5jruw==","section-title":"Jh+v0Iszh8yvXIk8NCJVuw=="};